import { FaArrowUpLong } from "react-icons/fa6";
import { Button, Card, CardBody, CardImg, CardText, CardTitle, Col, Row } from "reactstrap";
import { FiSearch, FiShare2 } from "react-icons/fi";
import { FaArrowTurnUp } from "react-icons/fa6";
import { LuPin } from "react-icons/lu";
import { RiDirectionLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";
import { useEffect, useState } from "react";
import MapComponent from "../specials/MapComponent";
import { useDeviceLocation } from "../../hooks/utilityHooks";
import { FaDirections } from "react-icons/fa";

const DirectionMap = ({ onModeChange, placeData = {} }) => {
  const modes = {
    LOCATION_MARK: "location-mark",
    ROUTE_FINDING: "route-finding",
    STARTED: "started",
  };

  const { location } = useDeviceLocation(true);

  console.log("placeData", placeData);

  const [currentMode, setCurrentMode] = useState(modes.LOCATION_MARK);
  const [mapCenter, setMapCenter] = useState({ lat: 33, lng: 34 });

  // Route data for the polyline
  const [routeData, setRouteData] = useState({
    start: null,
    end: null,
    path: [], // Will be filled with the line/path
  });

  // Compute map center
  const calculateCenter = () => {
    return { lat: location?.latitude, lng: location?.longitude }
  };

  // When switching to route-finding mode, create route between user and place
  useEffect(() => {
    // Only create route if we have both user location and place data
    if (!location?.latitude || !placeData?.geo?.coordinates) return;
  
    let routeDataObj = {
      path: [
        { lat: location?.latitude, lng: location?.longitude },
        {
          lat: placeData?.geo?.coordinates?.[1],
          lng: placeData?.geo?.coordinates?.[0],
        }
      ],
      start: { lat: location?.latitude, lng: location?.longitude },
      end: {
        lat: placeData?.geo?.coordinates?.[1],
        lng: placeData?.geo?.coordinates?.[0],
      },
    }
    console.log("Route-data-obj.....",routeDataObj)
    
    setRouteData(routeDataObj);

    onModeChange(currentMode, modes);
  }, [placeData,location,currentMode]);



  useEffect(() => {
    setMapCenter(calculateCenter());
  }, [placeData,location]);




  return (
    <div className="position-relative direction-map-container">
      {currentMode === modes.STARTED && (
        <div style={{zIndex:10}} className="d-flex direction-content flex-column align-items-start position-absolute ">
          <div className="first-div d-flex figma-shadow-1 justify-content-between align-items-center text-white ">
            <FaArrowUpLong size={25} />
            <h4 className=" m-0">First div</h4>
            <Button
              style={{ height: 37, width: 37 }}
              className="border-none color-primary-blue d-flex align-items-center justify-content-center bg-white rounded-full p-0"
            >
              <FiSearch size={21} />
            </Button>
          </div>
          <div className="second-div text-white d-flex align-items-center gap-2">
            <h4 className=" m-0">Second div</h4>
            <FaArrowTurnUp size={25} />
          </div>
        </div>
      )}

      {/* Map area */}
      <div
        className={`px-1 ${currentMode === modes.ROUTE_FINDING ? "" : "mt-5"}`}
      >
        <MapComponent
          firstMarkerLabel={"You"}
          secondMarkerLabel={placeData?.name}
          mode={currentMode}
          center={mapCenter}
          routePath={routeData.path}
          markers={[routeData.start, routeData.end]}
          userLocation={location}
          containerStyle={{ height:currentMode===modes.STARTED?"70vh": 500 }}
          
          individualPlaceData={placeData}
        />
      </div>

      {/* LOCATION_MARK Mode */}
      {currentMode === modes.LOCATION_MARK && (
        <div className="d-flex justify-content-end px-lg-5 px-3">
          <Button
            onClick={() => setCurrentMode(modes.ROUTE_FINDING)}
            className="my-5 figma-shadow-1 bg-primary-blue"
            style={{
              height: 84,
              width: 84,
              borderRadius: "20px",
              border: "1.68px solid rgba(255, 255, 255, 0.78)",
            }}
          >
            <FaDirections size={40} />
          </Button>
        </div>
      )}

      {/* ROUTE_FINDING Mode */}
      {currentMode === modes.ROUTE_FINDING && (
        <div className="px-lg-5 px-3 mb-4 d-flex gap-4 pt-4 flex-wrap justify-content-between">
          <div>
            <div className="d-flex align-items-center gap-2 mb-2">
              <h4 className="color-primary-orange-1 m-0">10 min</h4>
              <h4 className="color-primary-black-8 m-0">(5.4 km)</h4>
            </div>
            <h5 className="color-primary-black-8 m-0 f-4">
              Fastest route, despite the usual traffic
            </h5>
          </div>

          <div className="d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between gap-3 gap-md-4">
            <Button
              onClick={() => setCurrentMode(modes.STARTED)}
              style={{ borderRadius: "81px" }}
              className=" bg-primary-blue border-transparent full-width gap-2 px-4 d-flex align-items-center py-3"
            >
              <FaDirections
                style={{ transform: "rotate(270deg)" }}
                size={28}
              />
              <h5 className="m-0">Start</h5>
            </Button>
            <Button
              style={{ borderRadius: "81px" }}
              className=" bg-transparent full-width color-primary-blue border-primary-blue gap-2 d-flex align-items-center px-4 py-3"
            >
              <LuPin size={28} />
              <h5 className="m-0">Pin</h5>
            </Button>
            <Button
              style={{ borderRadius: "81px" }}
              className=" bg-transparent full-width color-primary-blue border-primary-blue gap-2 d-flex align-items-center px-4 py-3"
            >
              <FiShare2 size={28} />
              <h5 className="m-0">Share</h5>
            </Button>
          </div>
        </div>
      )}

      {/* STARTED Mode */}
      {currentMode === modes.STARTED && (
        <div className="px-3 mb-3">
          <Row className="my-lg-0 gy-2 gx-lg-5 gy-md-0">
            <Col md={9} xl={10}>
              <div
                className="d-flex px-3 px-lg-5 align-items-center justify-content-between"
                style={{
                  background: "rgba(0, 0, 0, 0.76)",
                  minHeight: "94px",
                  borderRadius: "8px",
                }}
              >
                <Button
                  onClick={() => setCurrentMode(modes.LOCATION_MARK)}
                  className="figma-big-rounded-btn"
                >
                  <RxCross2 size={37} />
                </Button>
                <div>
                  <h3 className="color-primary-orange-1 mb-2 text-center">
                    10 min
                  </h3>
                  <h5 className="text-white m-0 f-4">4.3km . 03 : 24 pm</h5>
                </div>
                <Button className="figma-big-rounded-btn">
                  <RiDirectionLine size={37} />
                </Button>
              </div>
            </Col>
            <Col xl={2} md={3} className="d-flex align-items-center">
              <Button
                style={{ borderRadius: "110.46px" }}
                className="bg-white border-none figma-shadow-2 py-3 full-width color-dodgerblue"
              >
                <h5 className="m-0">Re-center</h5>
              </Button>
            </Col>
          </Row>
        </div>
      )}
    </div>
  );
};

export default DirectionMap;
